import React from 'react';
import {createRoot} from 'react-dom/client';

import './common/styles/index.scss';
import Comparison from "./common/components/Comparison";

const App = () => {
    return (
        <Comparison/>
    );
};

class WebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<App  />);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

const ELEMENT_ID = 'up2date-comparison-table';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}
